import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/RegistrationDeliveryHistorical/${dossierId}/Dependants`, method: 'GET', token: token })
}
